import './comboResume.scss';

import { Button } from 'react-bootstrap';

import { useWebContext } from '@/resources/hooks/useWebContext';

export default function ComboResumeCard({
  comboName,
  children,
  onEdit,
}: {
  comboName: string;
  children: React.ReactNode;
  onEdit?: () => void;
}) {
  const { setMenuOpen } = useWebContext();

  const handleEditClick = () => {
    if (onEdit) {
      onEdit();
    } else {
      setMenuOpen(true);
    }
  };

  return (
    <div className="combo-resume-card" style={{ backgroundColor: '#F6993F' }}>
      <div
        className="d-flex flex-row justify-content-between mb-0 pl-1"
        style={{ marginTop: '-0.4rem' }}
      >
        <span className="combo-title">Combo {comboName}</span>
        <Button
          variant="link"
          onClick={handleEditClick}
          className="p-0 m-0 ml-2 pr-1 combo-edit-button"
          style={{ textDecoration: 'none', color: '#000000' }}
        >
          Editar
        </Button>
      </div>
      {children}
    </div>
  );
}
